import * as React from 'react';
import CartesianGrid from 'recharts/es6/cartesian/CartesianGrid';
import Line from 'recharts/es6/cartesian/Line';
import XAxis from 'recharts/es6/cartesian/XAxis';
import YAxis from 'recharts/es6/cartesian/YAxis';
import Legend from 'recharts/es6/component/Legend';
import Tooltip from 'recharts/es6/component/Tooltip';
import RechartsLineChart from 'recharts/es6/chart/LineChart';
import ResponsiveContainer from 'recharts/es6/component/ResponsiveContainer';
import Text from 'recharts/es6/component/Text';
import { numberWithCommas } from './format';

interface LineChartProps {
  data: object[];
  width: string;
  height: string;
  dataKeys: Array<{ name: string; color: string }>;
  isMobile: boolean;
}

const LineChart = ({ data, width, height, dataKeys, isMobile }: LineChartProps) => (
  <ResponsiveContainer width={width} height={height} minHeight={isMobile ? '250px' : '350px'}>
    <RechartsLineChart data={data} margin={{ top: 10, right: 50, left: 35, bottom: 15 }}>
      <XAxis dataKey="month" />
      <YAxis tick={CustomTick} />
      <CartesianGrid strokeDasharray="3 3" />
      <Tooltip />
      <Legend verticalAlign="top" height={36} />
      {dataKeys.map(key => (
        <Line
          key={key.name || ''}
          type="monotone"
          dot={{ fill: key.color }}
          strokeWidth={3}
          dataKey={key.name}
          stroke={key.color}
        />
      ))}
    </RechartsLineChart>
  </ResponsiveContainer>
);

const CustomTick = (props: any) => (
  <Text {...props}>{'$' + numberWithCommas(props.payload.value)}</Text>
);

export default LineChart;
